<div class="wip-container">
    <div class="wip-gear">⚙️</div>
    <h1>Work in Progress</h1>
    <p>This page is under construction. Please check back soon!</p>
  </div>
  